import { GridApi, IGetRowsParams } from 'ag-grid-community';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../Compliance/AgGrid';
import { lastValueFrom } from 'rxjs';
import { CapRuleRepository } from '../../Compliance/Repositories/capRule.repository';

export class CapRuleListDataSource extends AgGridDataSourceBase<void> {
    constructor(private _gridApi: GridApi,
                private _capRuleRepository: CapRuleRepository){
        super(_gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.CapRulePropertyEnum>[] = [
        { name: 'stateAbbr', value: Core.CapRulePropertyEnum.State },
        { name: 'propertyType', value: Core.CapRulePropertyEnum.PropertyType },
        { name: 'assessmentComponentName', value: Core.CapRulePropertyEnum.AssessmentComponent },
        { name: 'taxYearBegin', value: Core.CapRulePropertyEnum.TaxYearBegin },
        { name: 'taxYearEnd', value: Core.CapRulePropertyEnum.TaxYearEnd },
        { name: 'capRulePredefinedName', value: Core.CapRulePropertyEnum.CapRulePredefined },
        { name: 'capValueRange', value: Core.CapRulePropertyEnum.CapValueRange },
        { name: 'mayCapExceedAV', value: Core.CapRulePropertyEnum.MayCapExceedAV },
        { name: 'defaultAnnualPercentIncrease', value: Core.CapRulePropertyEnum.DefaultAnnualPercentIncrease },
        { name: 'statusUpdate', value: Core.CapRulePropertyEnum.StatusUpdate }
    ]

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.CapRuleSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap),
        };

        const result = await lastValueFrom(this._capRuleRepository.getList(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows,
            lastModifiedTimestamp: result.lastModifiedTimestamp
        };

    }
    protected canGetRows(): boolean {
        return true;
    }
}
